export enum UploadingStatusEnum {
  idle = 'idle',
  progress = 'progress',
  warning = 'warning',
  success = 'success',
}
